var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Styles
import { Container } from '../../../common/styles/container';
import { getDropdownListStylesByVariant } from './getDropdownListStylesByVariant';
// Utils
import styled, { css } from 'styled-components';
import { ZIndex } from '../../../common/types/ZIndex';
import { grey } from '../../../common/styles/colours';
export var DropdownList = styled(Container).attrs(function () { return ({
    role: 'list',
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  max-height: 300px;\n  width: ", ";\n  overflow-y: auto;\n  margin: 0;\n  padding: 4px;\n  box-sizing: border-box;\n  z-index: ", ";\n  ", "\n\n  word-break: break-word;\n\n  ", "\n"], ["\n  display: block;\n  max-height: 300px;\n  width: ", ";\n  overflow-y: auto;\n  margin: 0;\n  padding: 4px;\n  box-sizing: border-box;\n  z-index: ", ";\n  ", "\n\n  word-break: break-word;\n\n  ",
    "\n"])), function (_a) {
    var width = _a.width;
    return width || 'fit-content';
}, ZIndex.DROPDOWN, function (_a) {
    var theme = _a.theme;
    return getDropdownListStylesByVariant('default', theme);
}, function (_a) {
    var _b;
    var highlightedOptionIndex = _a.highlightedOptionIndex, theme = _a.theme, className = _a.className;
    return highlightedOptionIndex >= 0 && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", " > div:nth-child(", ") {\n        background-color: ", ";\n      }\n    "], ["\n      ", " > div:nth-child(", ") {\n        background-color: ", ";\n      }\n    "])), className, highlightedOptionIndex + 1, (_b = theme.recordsFinancialPrimary) !== null && _b !== void 0 ? _b : grey[50]);
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=DropdownList.js.map